export const isOldSKU = (sku: string): boolean => {
    return sku.startsWith('bdms');
};
